import { rootApi } from 'root-api'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['BlockedSources'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchBlockedSources: build.query({
      query: ({ userId, page, sortBy, sortOrder, perPage }) => ({
        url: `/api/users/${userId}/blocked_sources_settings`,
        method: 'GET',
        params: {
          page,
          page_size: perPage,
          sort_by: sortBy,
          sort_order: sortOrder,
        },
      }),
      providesTags: ['BlockedSources']
    }),
    unblockSource: build.mutation({
      query: ({ userId, id, location }) => ({
        url: `/api/users/${userId}/blocked_sources_settings/${id}`,
        method: 'DELETE',
        ...(location ? { params: { location } } : {}),
      }),
      invalidatesTags: ['BlockedSources'],
    }),
  }),
  overrideExisting: true,
})

export const { useFetchBlockedSourcesQuery, useUnblockSourceMutation } = api
